import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { mdlLanguage } from "../../../models/ui-models/Language";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircle, faUsd } from "@fortawesome/free-solid-svg-icons";
import { mdlFactSheetTemplate } from "../../../models/domain/FactSheetTemplate";
import { mdlFactSheetInfo } from "../../../models/domain/FactSheetInfo";
import { Skeleton } from "antd";
import { InputHelper } from "../../../utils/InputHelper";

export type CityTemplateProps = {
    printMode?: boolean;
    data?: mdlFactSheetTemplate;
    selectedHotel?: string;
    selectedLanguage?: mdlLanguage;
}

export const CityTemplate = function CityTemplate(props: CityTemplateProps) {
    const [templateData, setTemplateData] = useState<mdlFactSheetTemplate>();
    const [loader, setLoader] = useState<boolean>(false);
    const { t } = useTranslation();
    useEffect(() => {
        if (props.selectedHotel && !loader) {
            setTemplateData(props.data)
        }
    }, [props]);

    const renderCheckItem = (text: string, hasPrice = false, value : string) => (
        <div className="flex items-center report-line py-1.5 mb-1" style={{position: "relative"}}>
            {hasPrice &&
                <span className="fa-layers" style={{ position: 'absolute', left: '-20px', top: (props.printMode != null ? '13px' : '0'), color: '#0c4783' }}>
                    <FontAwesomeIcon icon={faCircle} fontSize={35} />
                    <FontAwesomeIcon icon={faUsd} color={"white"} fontSize={10} />
                </span>
            }
            <FontAwesomeIcon icon={faCheck} color="#0c4783" style={{ marginRight: '10px' }} />
            <span className="text-gray-600 text-sm">{text} { ( !InputHelper.isNullOrUndefinedOrEmpty(value) && value.toLowerCase() != "true" ? ` : ${value}` : "")}</span>
        </div>
    );

    return (
        !templateData ?
        <>
            <Skeleton />
        </>
        :
        <>
            {/* Hotel Info Header */}
            <div className="row g-0 mb-4 " style={{width:(props.printMode != null && props.printMode ? '1000px' : 'auto')}}>
                <div className="col-12 text-center pt-3" style={{ backgroundColor: '#0c4783' }}>
                    <div className="d-flex flex-column align-items-center justify-content-center py-3">
                        <div className="d-flex align-items-center report-line mb-2">
                            <div className="d-flex">
                                {
                                    templateData && templateData.star &&
                                    Array.from({ length: templateData.star }, (_, index) => (
                                        <span style={{ color: '#ffd800', fontSize: "25px"  }}>★</span>
                                    ))
                                }
                            </div>
                        </div>
                        <h1 className="text-white h5">{templateData.hotelName}</h1>
                    </div>
                    <div className="d-flex align-items-center text-center mb-4">
                        <label className="text-white p-2 mx-auto" style={{backgroundColor: '#373737'}}>{templateData?.hotelLocation}</label>
                    </div>
                </div>
            </div>

            
            {/* Image Gallery */}
            <div className="px-4 mb-4" style={{width:(props.printMode != null && props.printMode ? '1000px' : 'auto')}}>
                <div className="row g-4">
                    {
                        templateData?.images &&
                        templateData?.images.map((_, index) => (
                            <div key={index} className="col-3">
                                <div className="border border-4 border-white rounded shadow-sm"
                                    style={{ aspectRatio: '4/3' }}>
                                    <img
                                        src={_.value}
                                        className="w-100 h-100 object-fit-cover"
                                        style={{width:(props.printMode != null && props.printMode ? '250px' : 'auto')}}
                                    />
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>

            {
                templateData && templateData.list &&
                Array.from(templateData.list.reduce((map, item:mdlFactSheetInfo) => map.set(item.categoryId, item.categoryName), new Map()).values()).map(item =>
                    <div className="px-4" >
                        <div className="mb-4">
                            <h2 className="border-bottom border-2 pb-2 mb-2 h5">
                                <span style={{ color: '#0c4783', padding: "5px" }}>
                                {item}
                                </span>
                            </h2>
                            <div className="row" style={{width:(props.printMode != null && props.printMode ? '1000px' : 'auto')}}>
                                {
                                    templateData.list?.filter(x => x.categoryName == item).map((info: mdlFactSheetInfo , subIndex: number) => (
                                        info.questionName &&
                                        <div className="col-3">
                                            {renderCheckItem(info.questionName, info.isExtra, info.value || "")}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        
                    </div>
                )
            }
        </>
    )
}